<div class="payment-portal" *ngIf="orderForm" [formGroup]="orderForm">
  <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px" class="financial-layout">
    <div fxFlex class="financial-main">

  <div class="payment-block" *ngIf="availableCredit > 0">
    <div class="summary-title">AVAILABLE CREDIT</div>
    <p>
      {{ patient?.lastName }}, {{ patient?.firstName }} — ${{ formatMoney(availableCredit) }}
    </p>
    <button mat-stroked-button type="button" [disabled]="busy || !canPay" (click)="applyCredit()">
      APPLY CREDIT
    </button>
    <mat-form-field style="width:100%">
      <mat-label>TRANSFER CREDIT TO PATIENT ID</mat-label>
      <input matInput [(ngModel)]="transferPatientId" [ngModelOptions]="{standalone: true}" autocomplete="off">
    </mat-form-field>
    <mat-form-field style="width:100%">
      <mat-label>TRANSFER AMOUNT</mat-label>
      <span matPrefix>$&nbsp;</span>
      <input matInput [(ngModel)]="transferAmount" [ngModelOptions]="{standalone: true}" autocomplete="off">
    </mat-form-field>
    <button mat-button type="button" [disabled]="busy" (click)="transferCredit()">TRANSFER CREDIT</button>
  </div>

  <div class="payment-block" *ngIf="orderForm.get('superbillRequested')?.value">
    <div class="summary-title">SUPERBILL</div>
    <p>Requested. AutoOptiq emails the superbill when this order is paid in full.</p>
  </div>

  <div class="payment-block">
    <div class="payment-field-row">
      <mat-form-field class="payment-date-field">
        <mat-label>REQUESTED COMPLETION DATE</mat-label>
        <input matInput type="date" formControlName="requestedCompletionDate">
      </mat-form-field>
      <mat-form-field class="payment-discount-field">
        <mat-label>DISCOUNT / PROMO</mat-label>
        <mat-select formControlName="discountId">
          <mat-option value="">NONE</mat-option>
          <mat-option *ngFor="let discount of discounts" [value]="discount._id" [disabled]="discount.active === false">
            {{ discount.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="payment-block">
    <div class="summary-title">PAYMENT</div>
    <div class="payment-field-row">
      <mat-form-field class="payment-contact-field">
        <mat-label>METHOD</mat-label>
        <mat-select [(ngModel)]="paymentMethod" [ngModelOptions]="{standalone: true}">
          <mat-option value="CREDIT CARD">CREDIT CARD</mat-option>
          <mat-option value="GIFT CARD">SQUARE GIFT CARD</mat-option>
          <mat-option value="CASH">CASH</mat-option>
          <mat-option value="CHECK">CHECK</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="payment-contact-field">
        <mat-label>PAYER (IF DIFFERENT FROM PATIENT)</mat-label>
        <input matInput [(ngModel)]="payerName" [ngModelOptions]="{standalone: true}" autocomplete="off">
      </mat-form-field>
    </div>
    <div class="terminal-block" *ngIf="showTerminalBlock">
      <p class="terminal-copy" *ngIf="terminalConfigured && terminalPaired && !terminalSandbox">
        Customer pays on the Square Terminal.
      </p>
      <p class="terminal-copy" *ngIf="terminalConfigured && terminalSandbox">
        Credit card in development uses a simulated Square Terminal. Pay in Full waits as if the customer is tapping the device, then Approve or Decline any amount. Do not pair the shop Terminal here.
      </p>
      <p class="terminal-copy" *ngIf="terminalConfigured && !terminalPaired && !terminalSandbox">
        Pair the Square Terminal once. On the device, open Settings and enter the pairing code.
      </p>
      <div class="terminal-code" *ngIf="terminalCode">
        {{ terminalCode }}
      </div>
      <p class="terminal-wait" *ngIf="isProcessing || terminalStatusLabel">
        {{ terminalStatusLabel || 'Processing' }}
      </p>
      <div class="gift-card-block" *ngIf="paymentMethod === 'GIFT CARD'">
        <mat-form-field style="width:100%">
          <mat-label>GIFT CARD NUMBER</mat-label>
          <input matInput [(ngModel)]="giftCardNumber" [ngModelOptions]="{standalone: true}" autocomplete="off">
        </mat-form-field>
        <button mat-stroked-button type="button" [disabled]="busy" (click)="checkGiftCardBalance()">
          CHECK BALANCE
        </button>
        <p class="terminal-copy" *ngIf="giftCardLast4">
          Card {{ giftCardLast4 }} — ${{ formatMoney(giftCardBalance) }} available.
          <span *ngIf="giftCardBalance != null && giftCardBalance < payInFullAmount">
            Apply this balance, then take the remaining ${{ formatMoney(payInFullAmount - giftCardBalance) }} with another method.
          </span>
        </p>
      </div>
      <button
        mat-stroked-button
        type="button"
        [disabled]="busy"
        (click)="pairTerminal()"
        *ngIf="terminalConfigured && !terminalSandbox && !terminalPaired"
      >
        PAIR SQUARE TERMINAL
      </button>
      <button
        mat-button
        type="button"
        *ngIf="terminalCheckoutId"
        (click)="cancelTerminalCheckout()"
      >
        CANCEL TERMINAL CHECKOUT
      </button>
    </div>

    <div class="payment-block remote-block">
      <div class="summary-title">REMOTE PAYMENT</div>
      <div class="remote-contact-row">
        <mat-form-field class="payment-contact-field">
          <mat-label>EMAIL</mat-label>
          <input matInput [(ngModel)]="remoteEmail" [ngModelOptions]="{standalone: true}" autocomplete="off">
        </mat-form-field>
        <mat-form-field class="payment-contact-field">
          <mat-label>MOBILE</mat-label>
          <input matInput [(ngModel)]="remotePhone" [ngModelOptions]="{standalone: true}" autocomplete="off">
        </mat-form-field>
      </div>
      <p class="terminal-copy" *ngIf="lastPaymentGroup?.status === 'SENT'">
        {{ lastPaymentGroup.status }} — {{ lastPaymentGroup.paymentLinkUrl }}
      </p>
      <button
        mat-stroked-button
        type="button"
        [disabled]="busy || !orderId || orderId === 'NEW'"
        (click)="sendRemotePayment('email')"
      >
        EMAIL PAYMENT LINK
      </button>
      <button
        mat-stroked-button
        type="button"
        [disabled]="busy || !orderId || orderId === 'NEW'"
        (click)="sendRemotePayment('sms')"
      >
        TEXT PAYMENT LINK
      </button>
      <button
        mat-button
        type="button"
        *ngIf="lastPaymentGroup?.status === 'SENT'"
        (click)="cancelRemotePayment()"
      >
        CANCEL REQUEST
      </button>
    </div>

    <div class="pay-lines">
      <mat-checkbox
        [checked]="payFullSelected"
        (change)="togglePayFull($event)"
      >
        PAY IN FULL — ${{ formatMoney(orderBalance) }}
      </mat-checkbox>
      <mat-form-field class="also-pay-amount" floatLabel="always">
        <mat-label>CUSTOM AMOUNT</mat-label>
        <span matPrefix>$&nbsp;</span>
        <input
          matInput
          [ngModel]="customAmount"
          (ngModelChange)="setCustomAmount($event)"
          [ngModelOptions]="{standalone: true}"
          autocomplete="off"
          (blur)="formatCustomAmount()"
        >
      </mat-form-field>

      <ng-container *ngIf="openInvoiceList.length">
        <div class="summary-title pay-lines-span">ALSO PAY</div>
        <p class="terminal-copy pay-lines-span" *ngIf="extraPatientInvoices.length">
          Family / Linked Patients — check a job to include its full balance, or enter a custom amount. Each job keeps its own allocation.
        </p>
        <ng-container *ngFor="let invoice of openInvoiceList">
          <mat-checkbox
            [checked]="isInvoiceSelected(invoice)"
            (change)="toggleInvoice(invoice._id, $event)"
          >
            {{ formatInvoiceNumber(invoice.invoiceNumber) }}
            <span *ngIf="invoicePatientName(invoice)"> — {{ invoicePatientName(invoice) }}</span>
            — ${{ formatMoney(invoice.financials?.balanceDue) }}
          </mat-checkbox>
          <mat-form-field class="also-pay-amount" floatLabel="always">
            <mat-label>CUSTOM AMOUNT</mat-label>
            <span matPrefix>$&nbsp;</span>
            <input
              matInput
              [ngModel]="alsoPayAmounts[invoice._id] || ''"
              (ngModelChange)="setAlsoPayAmount(invoice._id, $event)"
              [ngModelOptions]="{standalone: true}"
              autocomplete="off"
              (blur)="formatAlsoPay(invoice)"
            >
          </mat-form-field>
        </ng-container>
      </ng-container>
    </div>

    <p class="terminal-copy" *ngIf="financials.tax > 0">
      Sales tax ${{ formatMoney(financials.tax) }}<span *ngIf="appliedTaxRate > 0"> at {{ appliedTaxRate }}%</span> is included in the order total.
    </p>
    <button
      mat-raised-button
      color="primary"
      type="button"
      [disabled]="busy || !canPay || ((paymentMethod === 'CREDIT CARD' || paymentMethod === 'GIFT CARD') && !terminalPaired)"
      (click)="pay()"
    >
      PAY ${{ formatMoney(chargeTotal) }}
    </button>
  </div>

  <div class="payment-block" *ngIf="lastPaymentGroup && (lastPaymentGroup.status === 'COMPLETED' || lastPaymentGroup.status === 'PARTIAL')">
    <div class="summary-title">LAST RECEIPT</div>
    <p class="receipt-line">
      <button
        type="button"
        class="receipt-copy"
        (click)="copyReceiptCode()"
        [attr.aria-label]="'Copy ' + lastPaymentGroup.groupKey"
      >
        {{ lastPaymentGroup.groupKey }}
        <mat-icon class="receipt-copy-icon" aria-hidden="true">content_copy</mat-icon>
      </button>
      — ${{ formatMoney(lastPaymentGroup.collected || lastPaymentGroup.total) }}
      {{ lastPaymentGroup.status }}
    </p>
    <p *ngFor="let line of allocationLines()">
      Invoice {{ line.invoice }} — ${{ formatMoney(line.amount) }}
    </p>
    <p class="terminal-copy" *ngIf="lastPaymentGroup.remaining > 0">
      Remaining ${{ formatMoney(lastPaymentGroup.remaining) }}. Take another method on this same payment group.
    </p>
  </div>

  <div class="payment-block" *ngIf="lastRefundableGroup">
    <div class="summary-title">REFUND ORIGINAL PAYMENT</div>
    <mat-form-field style="width:100%">
      <mat-label>REFUND AMOUNT</mat-label>
      <span matPrefix>$&nbsp;</span>
      <input matInput [(ngModel)]="refundAmount" [ngModelOptions]="{standalone: true}" autocomplete="off">
    </mat-form-field>
    <mat-form-field style="width:100%">
      <mat-label>REASON</mat-label>
      <input matInput [(ngModel)]="refundReason" [ngModelOptions]="{standalone: true}" autocomplete="off">
    </mat-form-field>
    <button mat-stroked-button type="button" [disabled]="busy" (click)="refundLastGroup()">
      REFUND
    </button>
  </div>

  <div class="payment-block">
    <button mat-button type="button" (click)="historyOpen = !historyOpen">
      {{ historyOpen ? 'HIDE' : 'SHOW' }} PAYMENT HISTORY
    </button>
    <div *ngIf="historyOpen">
      <p *ngIf="!events.length">No financial events yet.</p>
      <p *ngFor="let event of events">{{ eventLabel(event) }}</p>
    </div>
    <div class="ack-actions">
      <button mat-button type="button" (click)="printSummary()">PRINT ORDER SUMMARY</button>
      <button mat-button type="button" (click)="emailSummary()">EMAIL ORDER SUMMARY</button>
    </div>
  </div>

    </div>
    <div fxFlex="0 0 225px" class="financial-sidebar">
      <mat-card appearance="outlined" class="frame-pricing-box">
        <mat-card-content>
          <mat-form-field style="width:100%" *ngFor="let row of summaryRowList" floatLabel="always">
            <mat-label>{{ row.label }}</mat-label>
            <input
              matInput
              [value]="formatMoney(row.value)"
              readonly
              autocomplete="off"
            >
            <span matPrefix>$&nbsp;</span>
          </mat-form-field>
          <div class="suggested-deposit" *ngIf="financials.balanceDue > 0">
            Suggested 50% deposit ${{ formatMoney(financials.suggestedDeposit) }}
          </div>
        </mat-card-content>
      </mat-card>
      <mat-card appearance="outlined" class="frame-pricing-box">
        <mat-card-content>
          <mat-form-field style="width:100%" floatLabel="always">
            <mat-label>TYPE</mat-label>
            <mat-select
              [(ngModel)]="otherCreditType"
              [ngModelOptions]="{standalone: true}"
            >
              <mat-option value="Frame Credit">Frame Credit</mat-option>
              <mat-option value="Lens Credit">Lens Credit</mat-option>
              <mat-option value="Frame + Lens Credit">Frame + Lens Credit</mat-option>
              <mat-option value="Return Credit">Return Credit</mat-option>
              <mat-option value="Restyle Credit">Restyle Credit</mat-option>
              <mat-option value="Custom Credit">Custom Credit Amount</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field style="width:100%" floatLabel="always">
            <mat-label>AMOUNT</mat-label>
            <input
              matInput
              [(ngModel)]="otherCreditAmount"
              [ngModelOptions]="{standalone: true}"
              autocomplete="off"
            >
            <span matPrefix>$&nbsp;</span>
          </mat-form-field>
          <button
            mat-stroked-button
            class="sidebar-apply"
            type="button"
            [disabled]="busy || !orderId"
            (click)="applyOtherCredit()"
          >
            APPLY CREDIT
          </button>
          <mat-checkbox class="sidebar-pol" formControlName="pol">
            POL — PATIENT'S OWN LENSES
          </mat-checkbox>
          <mat-form-field style="width:100%" *ngIf="shippingControl" floatLabel="always">
            <mat-label>POSTAGE</mat-label>
            <input
              matInput
              [formControl]="shippingControl"
              autocomplete="off"
            >
            <span matPrefix>$&nbsp;</span>
          </mat-form-field>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
